<script setup lang="ts">
import { computed } from 'vue';

import { useDispatchDashboardViewStore } from '@/stores/useDispatchDashboardViewStore';

import tabsStyles from '@/styles/tabs.module.scss';

const dispatchDashboardViewStore = useDispatchDashboardViewStore();

const stops = computed(() => {
  return dispatchDashboardViewStore.activatedJob?.stops;
});
</script>

<template>
  <div :class="[$style.smartDispatchStopsTabs, tabsStyles.tabsWrapper]">
    <v-tabs
      v-model="dispatchDashboardViewStore.stopDetailsActivatedTabNum"
      :class="tabsStyles.tabs"
      grow
      :show-arrows="false"
    >
      <v-tab
        v-for="(stop, stopIndex) in stops"
        :key="stopIndex"
        :value="stopIndex + 1"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        Stop {{ stopIndex + 1 }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.smartDispatchStopsTabs {
}
</style>
